import { MessageCircle } from "lucide-solid";
import { type Component, Show } from "solid-js";
import { isAuthenticated } from "../../lib/auth";
import { Button } from "../ui/button";
import { chatOpen, setChatOpen } from "./chat-store";
import { ChatPanel } from "./ChatPanel";

export const ChatWidget: Component = () => {
  return (
    <Show when={isAuthenticated()}>
      <Show when={chatOpen()}>
        <ChatPanel />
      </Show>
      <Show when={!chatOpen()}>
        <Button
          class="fixed bottom-4 right-4 z-50 h-12 w-12 rounded-full shadow-lg"
          size="icon"
          onClick={() => setChatOpen(true)}
          title="Open assistant"
        >
          <MessageCircle class="h-5 w-5" />
        </Button>
      </Show>
    </Show>
  );
};
